import { createSelector } from 'reselect';

export const getNotifications = (state) => state.notificationsData;

export const getAlert = createSelector(
  getNotifications,
  (notificationsData) => notificationsData.alert
);
